// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const Chip = () => ({
   restrict: 'E',
   controller: ChipController,
   controllerAs: 'vm',

   // it's possible to define content with an <span ng-transclude='body'><html here/></span>
   transclude: { 
      body: '?chipBody'
   },

   template: '<button ng-if="vm.visible" type="button" ng-click="vm.closeFn()" class="btn btn-chip" id="chip_{{vm.name}}"><span class="closeChip">×</span><span ng-transclude="body"></span></button>',

   bindToController: {
      name: "@?",
      text: "<?",
      visible: "<?",
      actionFn: "&"
   }
})

class ChipController {
   actionFn: any
   name: any
   visible: any
   constructor() {
      this.$onInit = this.$onInit.bind(this)
   }

   $onInit() { 
      this.name = this.name || Date.now().toString(36) //random ID
      return this.visible = typeof this.visible === 'undefined' ? true : this.visible
   }

   closeFn() {
      this.visible = false
      // check if it's a function, and then call
      if (_.isFunction(this.actionFn)) {
         return this.actionFn()
      }
   }
}

angular.module('summonApp.directives') 
   .controller('chipController', ChipController)
   .directive('chip', Chip)
